import { ListItem, Text, UnorderedList } from '@chakra-ui/react';

import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { UnverifiableAggregate } from 'app/types/reconciliations';

/**
 * @description Columns of the aggregates a reconciliation run could not verify. The company column is left out in a
 * company's own view.
 */
function getUnverifiableAggregateColumns(showCompanyColumn = true) {
  const columnHelper = createColumnHelper<UnverifiableAggregate>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const columns: ColumnDef<UnverifiableAggregate, any>[] = [
    columnHelper.accessor('companyName', {
      id: 'company',
      header: 'Company',
      enableSorting: false,
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('individualName', {
      header: 'Person',
      enableSorting: false,
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('payrollId', {
      header: 'Payroll ID',
      enableSorting: false,
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('payCycleId', {
      header: 'Pay cycle',
      enableSorting: false,
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('periodAggregateId', {
      header: 'Aggregate',
      enableSorting: false,
      cell: (info) => <Text fontSize="xs">{info.getValue()}</Text>,
    }),
    columnHelper.accessor('reasons', {
      header: 'Why it could not be verified',
      enableSorting: false,
      cell: (info) => (
        <UnorderedList maxW="420px" whiteSpace="normal" spacing="2px">
          {(info.getValue() as string[]).map((reason) => (
            <ListItem key={reason}>{reason}</ListItem>
          ))}
        </UnorderedList>
      ),
    }),
  ];

  return showCompanyColumn ? columns : columns.filter((column) => column.id !== 'company');
}

export default getUnverifiableAggregateColumns;
